const ALLOW_FONT_SCALING = false;

export { ALLOW_FONT_SCALING };
